
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f0ov8", function(module, exports) {
$parcel$export(module.exports, "PasswordResetPage", function () { return (parcelRequire("c8NF0")).PasswordResetPage; });
parcelRequire("c8NF0");

});
parcelRegister("c8NF0", function(module, exports) {

$parcel$export(module.exports, "PasswordResetPage", function () { return $d7cf941d4fb1bf6b$export$5bbd98196cb66ba8; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");

var $j26DE = parcelRequire("j26DE");

var $23wDf = parcelRequire("23wDf");

var $igvrl = parcelRequire("igvrl");

var $d6Tic = parcelRequire("d6Tic");

var $7FZyo = parcelRequire("7FZyo");

var $aBfUs = parcelRequire("aBfUs");

var $ikjch = parcelRequire("ikjch");

var $c1FuV = parcelRequire("c1FuV");
parcelRequire("eFd5W");
var $a6N6h = parcelRequire("a6N6h");

var $1sDHO = parcelRequire("1sDHO");

var $5u6k9 = parcelRequire("5u6k9");
const $d7cf941d4fb1bf6b$var$SFormWrapper = (0, $gRonV.default)((0, $aBfUs.SContentWrapper))`
    width: 100%;
    max-width: 435px;
`;
function $d7cf941d4fb1bf6b$export$5bbd98196cb66ba8({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const { value: value, apply: apply } = (0, $d6Tic.default)({
        password: "",
        passwordCompare: ""
    });
    const [error, setError] = (0, $7E7Dk.useState)("");
    const [submitError, setSubmitError] = (0, $7E7Dk.useState)(false);
    const [showPassword, toggleShowPassword] = (0, $7E7Dk.useState)(false);
    const [showPasswordCompare, toggleShowPasswordCompare] = (0, $7E7Dk.useState)(false);
    const navigate = (0, $3um4r.useNavigate)();
    const [searchParams] = (0, $3um4r.useSearchParams)();
    const { execute: resetPassword, status: status } = (0, $23wDf.default)((token, value)=>(0, $c1FuV.default)(token, value).then(()=>{
            (0, $1sDHO.default).setItem("notification", {
                text: "msgPasswordReset"
            });
            navigate("/login", {
                replace: true
            });
        }).catch(()=>setSubmitError(true)));
    const handleSubmit = (0, $7E7Dk.useCallback)((event)=>{
        event.preventDefault();
        const token = searchParams?.get("token");
        if (!token) return;
        if (value.password !== value.passwordCompare) {
            setError(text("msgPasswordDoNotMatch"));
            return;
        }
        if (!(0, $j26DE.isPasswordLongEnough)(value.password)) {
            setError(text("msgPasswordToShortSignup"));
            return;
        }
        resetPassword(token, value);
    }, [
        value,
        searchParams
    ]);
    const changeValue = (value)=>{
        setError("");
        apply(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: "#ffffff",
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($d7cf941d4fb1bf6b$var$SFormWrapper, null, submitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SNotification), {
        "data-testid": "signInError",
        error: submitError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgPasswordNotChanged"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.FormHeader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "passwordForm",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ikjch.PasswordInput), {
        label: value.password.length > 0 ? text("lblPassword") : "",
        placeholder: text("lblPassword"),
        onChange: (value)=>changeValue({
                password: value
            }),
        showPassword: showPassword,
        message: !value.password ? text("msgMinimumPasswordLength") : null,
        error: error,
        errorTestId: "passwordInputError",
        toggleShowPasswordFlag: toggleShowPassword,
        hasText: value.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ikjch.PasswordInput), {
        label: value.passwordCompare.length > 0 ? text("lblConfirmPasswordField") : "",
        placeholder: text("lblConfirmPasswordField"),
        onChange: (value)=>changeValue({
                passwordCompare: value
            }),
        showPassword: showPasswordCompare,
        toggleShowPasswordFlag: toggleShowPasswordCompare,
        hasText: value.passwordCompare.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $a6N6h.SubmitButton), {
        disabled: !value.password || !value.passwordCompare || status === (0, $23wDf.Status).PENDING
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "btnResetPassword"
    }))))));
}

});
parcelRegister("j26DE", function(module, exports) {

$parcel$export(module.exports, "MIN_PASSWORD_LENGTH", function () { return $ca9d1ca435735fc1$export$6f63e37550343081; });
$parcel$export(module.exports, "MAX_FIRST_NAME_LENGTH", function () { return $ca9d1ca435735fc1$export$8d95a259802f436c; });
$parcel$export(module.exports, "MAX_LAST_NAME_LENGTH", function () { return $ca9d1ca435735fc1$export$a1ce64b0aabb67a7; });
$parcel$export(module.exports, "MAX_USER_EMAIL_LENGTH", function () { return $ca9d1ca435735fc1$export$e457d43a6d8db9d4; });
$parcel$export(module.exports, "MAX_MOBILE_LENGTH", function () { return $ca9d1ca435735fc1$export$b5adbff18555fae2; });
$parcel$export(module.exports, "isPasswordLongEnough", function () { return $ca9d1ca435735fc1$export$ff7e0dbee5b5a1ba; });
const $ca9d1ca435735fc1$export$6f63e37550343081 = 8;
const $ca9d1ca435735fc1$export$8d95a259802f436c = 50;
const $ca9d1ca435735fc1$export$a1ce64b0aabb67a7 = 50;
const $ca9d1ca435735fc1$export$e457d43a6d8db9d4 = 50;
const $ca9d1ca435735fc1$export$b5adbff18555fae2 = 50;
const $ca9d1ca435735fc1$export$ff7e0dbee5b5a1ba = (password)=>password.length >= $ca9d1ca435735fc1$export$6f63e37550343081;

});

parcelRegister("d6Tic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f21bdd020aa119e$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
const $2f21bdd020aa119e$var$isNaNType = (value)=>typeof value === "number" && isNaN(value);
const $2f21bdd020aa119e$var$isSame = (valueA, valueB)=>{
    if (typeof valueA !== typeof valueB) return false;
    if ($2f21bdd020aa119e$var$isNaNType(valueA) && $2f21bdd020aa119e$var$isNaNType(valueB)) return true;
    if (valueA === valueB) return true;
    if (typeof valueA !== "object") return false;
    if (valueA === null || valueB === null) return false;
    if (Array.isArray(valueA)) {
        if (!Array.isArray(valueB)) return false;
        if (valueA.length !== valueB.length) return false;
        return valueA.every((v, index)=>$2f21bdd020aa119e$var$isSame(v, valueB[index]));
    }
    const keysA = Object.keys(valueA);
    const keysB = Object.keys(valueB);
    if (keysA.length !== keysB.length) return false;
    if (keysA.some((key)=>!keysB.includes(key))) return false;
    return keysA.every((key)=>$2f21bdd020aa119e$var$isSame(valueA[key], valueB[key]));
};
const $2f21bdd020aa119e$var$selectDifferentProperties = (origin, patch)=>{
    return Object.keys(patch).reduce((diff, key)=>{
        return origin && key in origin && $2f21bdd020aa119e$var$isSame(patch[key], origin[key]) ? diff : Object.assign(diff, {
            [key]: patch[key]
        });
    }, {});
};
function $2f21bdd020aa119e$export$2e2bcd8739ae039(origin, patch) {
    const [diff, setDiff] = (0, $7E7Dk.useState)({});
    return (0, $7E7Dk.useMemo)(()=>({
            diff: diff,
            value: {
                ...origin,
                ...diff
            },
            apply: (changes)=>{
                const newDiff = patch ? patch(changes, diff, origin) : $2f21bdd020aa119e$var$selectDifferentProperties(origin, {
                    ...diff,
                    ...changes
                });
                setDiff(newDiff);
            },
            set: (changes)=>{
                const newDiff = patch ? patch(changes, {}, origin) : $2f21bdd020aa119e$var$selectDifferentProperties(origin, changes);
                setDiff(newDiff);
            },
            reset: ()=>setDiff({}),
            hasChanges: Boolean(Object.keys(diff).length)
        }), [
        origin,
        diff,
        setDiff
    ]);
}

});

parcelRegister("c1FuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641428a571353138$export$2e2bcd8739ae039; });

var $Ri8UW = parcelRequire("Ri8UW");
const $641428a571353138$var$resetUserPassword = (token, data)=>(0, $Ri8UW.default)({
        method: "PUT",
        path: `/auth/password/reset/${token}`,
        body: data
    });
var $641428a571353138$export$2e2bcd8739ae039 = $641428a571353138$var$resetUserPassword;

});

parcelRegister("eFd5W", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return (parcelRequire("a6N6h")).SubmitButton; });
parcelRequire("a6N6h");

});
parcelRegister("a6N6h", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", function () { return $e983d058c59b72be$export$8b7b7cdfb85d78c5; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $g7dDc = parcelRequire("g7dDc");

var $a9SdK = parcelRequire("a9SdK");

var $gHig1 = parcelRequire("gHig1");
const $e983d058c59b72be$export$e97afde9f5f901c8 = (0, $gRonV.default).button`
    display: flex;
    min-width: 150px;
    margin: 0 auto;
    padding: 9px 46px;
    border-radius: 16px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border: none;
    transition: 0.2s ease;
    font-size: 15px;
    svg {
        path {
            fill: ${({ theme: theme })=>theme.font.successColor};
        }
    }

    &[disabled],
    &[disabled]:active:not(:hover) {
        background-color: #e6e6e6;
        color: ${({ theme: theme })=>theme.font.lightestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &.inverted {
        background-color: #fff;
        color: #000;
    }

    &:hover {
        background-color: ${({ theme: theme })=>theme.font.successColor};
        color: #000;

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }
    &:active,
    &:active:not(:hover) {
        background-color: #d9edd9;
        color: ${({ theme: theme })=>theme.font.darkestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &[disabled]:hover {
        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
        color: ${({ theme: theme })=>theme.font.lightestColor};
        background-color: #e6e6e6;
    }
`;
function $e983d058c59b72be$export$8b7b7cdfb85d78c5({ children: children, className: className, style: style, inverted: inverted, disabled: disabled, loading: loading = false }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e983d058c59b72be$export$e97afde9f5f901c8, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className, {
            inverted: inverted
        }),
        style: style,
        "data-testid": "submitButton",
        type: "submit",
        disabled: disabled
    }, children, " ", !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gHig1.SignInArrowIcon), {
        className: "ml-2"
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
        icon: (0, $a9SdK.faSpinner),
        pulse: true,
        "data-testid": "spinner"
    }));
}

});




parcelRegister("aojuQ", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return (parcelRequire("39OeV")).ResetPasswordRequestPage; });
parcelRequire("39OeV");

});
parcelRegister("39OeV", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return $05431c58c88f1d21$export$d071176b85126a1a; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");

var $igvrl = parcelRequire("igvrl");

var $aBfUs = parcelRequire("aBfUs");

var $1O9Jh = parcelRequire("1O9Jh");

var $aoz19 = parcelRequire("aoz19");

var $iUBfY = parcelRequire("iUBfY");

var $3T14g = parcelRequire("3T14g");

var $7FZyo = parcelRequire("7FZyo");
parcelRequire("eFd5W");
var $a6N6h = parcelRequire("a6N6h");

var $eUJ8c = parcelRequire("eUJ8c");

var $5u6k9 = parcelRequire("5u6k9");
const $05431c58c88f1d21$var$SFormWrapper = (0, $gRonV.default)((0, $aBfUs.SContentWrapper))`
    max-width: 510px;
    padding: 0 10px;
`;
const $05431c58c88f1d21$var$SLink = (0, $gRonV.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        text-align: center;
        width: 100%;
        display: inline-block;
        padding-top: 30px;
    }
`;
const $05431c58c88f1d21$var$SInstruction = (0, $gRonV.default).div`
    line-height: 1.5em;
    padding-bottom: 37px;
    text-align: center;
`;
const $05431c58c88f1d21$var$SHeaderWrapper = (0, $gRonV.default).div`
    padding-bottom: 45px;
`;
function $05431c58c88f1d21$export$d071176b85126a1a({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const [email, setEmail] = (0, $7E7Dk.useState)("");
    const [errorMessage, setErrorMessage] = (0, $7E7Dk.useState)("");
    const navigate = (0, $3um4r.useNavigate)();
    const [requestPasswordReset, { isLoading: isLoading }] = (0, $1O9Jh.useAuthRequestPasswordResetMutation)();
    const handleSubmit = (0, $7E7Dk.useCallback)((event)=>{
        event.preventDefault();
        if (!(0, $iUBfY.validateEmailFormat)(email)) {
            setErrorMessage(text("msgEmailFormatIncorrect"));
            return;
        }
        requestPasswordReset({
            userCredentials: {
                email: email
            }
        }).unwrap().then(()=>{
            navigate("/reset-password-request-success", {
                replace: true
            });
        }).catch((error)=>{
            if ((0, $aoz19.getErrorMessageCode)(error) === "msgEmailDoesntExist") {
                setErrorMessage(text("msgEmailDoesntExist", {
                    company: "ChargeAmps"
                }));
                return;
            }
            navigate("/reset-password-request-error", {
                replace: true
            });
        });
    }, [
        email,
        navigate,
        requestPasswordReset,
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($05431c58c88f1d21$var$SFormWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($05431c58c88f1d21$var$SHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.FormHeader), {
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($05431c58c88f1d21$var$SInstruction, {
        "data-testid": "description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgChargeAmpsResetPasswordInstruction"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "form",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.InputGroup), {
        errorTestId: "errorMsg",
        errorMsg: errorMessage,
        inverted: false,
        label: email && text("lblEmail")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3T14g.SInput), {
        placeholder: text("lblEmail"),
        onInput: (event)=>{
            const value = event.target.value;
            setErrorMessage("");
            setEmail(value);
        },
        value: email,
        "data-testid": "emailInput"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $a6N6h.SubmitButton), {
        disabled: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "btnResetPassword"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($05431c58c88f1d21$var$SLink, {
        as: (0, $3um4r.Link),
        to: "/login",
        "data-testid": "returnBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "btnReturnToSignIn"
    }))));
}

});


parcelRegister("dm5pM", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return (parcelRequire("eFoMW")).ResetPasswordRequestSuccessPage; });
parcelRequire("eFoMW");

});
parcelRegister("eFoMW", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return $38e3b7308e8da8aa$export$4588528796d14202; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $3um4r = parcelRequire("3um4r");
parcelRequire("5TMkT");
var $hZpJD = parcelRequire("hZpJD");

var $aBfUs = parcelRequire("aBfUs");

var $igvrl = parcelRequire("igvrl");

var $eUJ8c = parcelRequire("eUJ8c");

var $5u6k9 = parcelRequire("5u6k9");
function $38e3b7308e8da8aa$export$4588528796d14202({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hZpJD.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>{
            navigate("/login", {
                replace: true
            });
        },
        type: (0, $hZpJD.LandingMessageType).SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgResetPasswordLinkSent"
    }))));
}

});
parcelRegister("5TMkT", function(module, exports) {
$parcel$export(module.exports, "LandingMessage", function () { return (parcelRequire("hZpJD")).LandingMessage; });
$parcel$export(module.exports, "LandingMessageType", function () { return (parcelRequire("hZpJD")).LandingMessageType; });
parcelRequire("hZpJD");

});
parcelRegister("hZpJD", function(module, exports) {

$parcel$export(module.exports, "LandingMessageType", function () { return $6d849d8c90a53197$export$ead8dc60ae5441ac; });
$parcel$export(module.exports, "LandingMessage", function () { return $6d849d8c90a53197$export$d88a99e06d24b3e0; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
parcelRequire("gkMDS");
var $1QSAB = parcelRequire("1QSAB");
parcelRequire("8OyAW");
var $2xAOj = parcelRequire("2xAOj");

var $eGqzt = parcelRequire("eGqzt");

var $eUJ8c = parcelRequire("eUJ8c");

var $7FZyo = parcelRequire("7FZyo");
const $6d849d8c90a53197$var$SWrapper = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const $6d849d8c90a53197$var$SIcon = (0, $gRonV.default).div`
    padding-bottom: 30px;
`;
const $6d849d8c90a53197$var$SBody = (0, $gRonV.default).div`
    width: 550px;
    padding-bottom: 61px;
    line-height: 1.5em;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    @media (max-width: 576px) {
        width: 100%;
    }
`;
const $6d849d8c90a53197$var$SLink = (0, $gRonV.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        cursor: pointer;
    }
`;
var $6d849d8c90a53197$export$ead8dc60ae5441ac;
(function(LandingMessageType) {
    LandingMessageType["SUCCESS"] = "success";
    LandingMessageType["ERROR"] = "error";
    LandingMessageType["INFO"] = "info";
})($6d849d8c90a53197$export$ead8dc60ae5441ac || ($6d849d8c90a53197$export$ead8dc60ae5441ac = {}));
var $6d849d8c90a53197$export$ea871832d7359f7e;
(function(LandingMessageTitle) {
    LandingMessageTitle["DEFAULT"] = "MyChargeSpace";
    LandingMessageTitle["ADMIN"] = "HaloAdmin";
})($6d849d8c90a53197$export$ea871832d7359f7e || ($6d849d8c90a53197$export$ea871832d7359f7e = {}));
const $6d849d8c90a53197$var$renderIcon = (type)=>{
    if (type) {
        if (type === "success") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1QSAB.LandingMessageSuccessIcon), null);
        if (type === "error") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2xAOj.LandingMessageErrorIcon), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGqzt.InfoIcon), {
            size: 90,
            fill: (0, $eUJ8c.theme).brandColors.CA_Green
        });
    }
};
function $6d849d8c90a53197$export$d88a99e06d24b3e0({ title: title, type: type, linkText: linkText, onClick: onClick, children: children, className: className, style: style, icon: icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($6d849d8c90a53197$var$SWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.FormHeader), {
        "data-testid": "header",
        className: "mb-6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($6d849d8c90a53197$var$SIcon, null, icon || $6d849d8c90a53197$var$renderIcon(type)), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h4", {
        className: "m-0 mb-3"
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($6d849d8c90a53197$var$SBody, null, children), linkText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($6d849d8c90a53197$var$SLink, {
        onClick: onClick,
        "data-testid": "linkBtn"
    }, linkText) : null);
}

});
parcelRegister("gkMDS", function(module, exports) {
$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return (parcelRequire("1QSAB")).LandingMessageSuccessIcon; });
parcelRequire("1QSAB");

});
parcelRegister("1QSAB", function(module, exports) {

$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return $5b33d7e3f90ca637$export$cd9c9d539c03064b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $5b33d7e3f90ca637$export$cd9c9d539c03064b({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: 90,
        height: 90,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        fill: "#81E18B"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "m30.03 52.553 7.364 7.375 30.94-30.941 1.044 1.043-31.985 31.985-8.407-8.42-2.536-2.54-5.578-5.588 1.044-1.042 5.578 5.587 2.536 2.54Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475ZM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45Z"
    })));
}

});


parcelRegister("8OyAW", function(module, exports) {
$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return (parcelRequire("2xAOj")).LandingMessageErrorIcon; });
parcelRequire("2xAOj");

});
parcelRegister("2xAOj", function(module, exports) {

$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return $f1aafea221fee0b1$export$651986bbbb409f50; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $f1aafea221fee0b1$export$651986bbbb409f50({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 90,
        height: 90,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        fill: "#DF0017"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "m63.596 27.08-5.902 5.9-1.844 1.845-28.77 28.77-1.044-1.043 28.77-28.77 1.845-1.844 5.901-5.902 1.044 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M62.92 63.595 26.406 27.08l1.043-1.043 36.516 36.516-1.043 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475zM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45z"
    })));
}

});






parcelRegister("a4GLo", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return (parcelRequire("8qloZ")).ResetPasswordRequestErrorPage; });
parcelRequire("8qloZ");

});
parcelRegister("8qloZ", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return $98fbaa11aca7762d$export$74ef4c4eee19ea3d; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");
parcelRequire("5TMkT");
var $hZpJD = parcelRequire("hZpJD");

var $aBfUs = parcelRequire("aBfUs");

var $eUJ8c = parcelRequire("eUJ8c");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
const $98fbaa11aca7762d$var$Title = (0, $gRonV.default).div`
    font-size: 24px;
    padding-bottom: 20px;
`;
function $98fbaa11aca7762d$export$74ef4c4eee19ea3d({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hZpJD.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $hZpJD.LandingMessageType).ERROR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($98fbaa11aca7762d$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSomethingWentWrong"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSignUpError"
    })));
}

});



//# sourceMappingURL=index.e408fbe5.js.map
